export default __webpack_public_path__ + "static/media/select.ca8f6fe7.webp";